import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const CheckboxUncheckedIcon: FC<IProps> = ({ width = 16, height = 16 }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
    <rect
      x="0.75" y="0.75" width="18.5" height="18.5"
      rx="3.25" stroke="#262626" strokeWidth="1.5"
    />
  </svg>
);

export default CheckboxUncheckedIcon;
